<template>
  <div class="row flex-row-reverse MainPageRow">
    <div class="col-12 d-flex flex-column justify-content-start">
      <b-nav tabs class="d-flex justify-content-between align-items-center">
        <div class="d-flex">
          <b-nav-item
            v-for="(menu, idx) in menuItems"
            :key="idx"
            :to="`${menu.route}?teamtaskName=${$route.query.teamtaskName}&tableId=${$route.query.tableId}&boardId=${$route.query.boardId}`"
            :active="$route.params.slug === menu.route"
            >{{ menu.persianName }}</b-nav-item
          >
        </div>
        <Button @click.native="submit()" text="ثبت و بروزرسانی" btnClass="ms-2 aprove btn-border float-end" :loading="btnLoading" />
      </b-nav>
      <transition name="slide-fade">
        <General v-if="components === 0" @boardName="boardName = $event" :value="boardName" :showError="showBoardError" :key="generalKey" />
        <Kanban v-else-if="components === 1" :key="generalKey + 1" />
        <Filters v-else-if="components === 2" :key="generalKey + 2" />
        <Table v-else-if="components === 4" :key="generalKey + 3" />
      </transition>
    </div>
  </div>
</template>

<script>
import Kanban from './kanban.vue'
import Button from '../../common/Button.vue'
import General from './general.vue'
import Filters from './filters.vue'
import Table from '../table/Table.vue'
import adminDataProvider from '../../../services/superAdmin'
import { superAdminMixins } from '../../../utils/mixins'
export default {
  components: {
    Kanban,
    Button,
    General,
    Filters,
    Table,
  },
  mixins: [superAdminMixins],
  data() {
    return {
      components: 0, // 0 is default for general
      boardName: '',
      showBoardError: null,
      generalKey: 0,
      menuItems: [
        {
          route: 'general',
          persianName: 'عمومی',
        },
        {
          route: 'list',
          persianName: 'لیست',
        },
        {
          route: 'kanban',
          persianName: 'کانبون',
        },
        {
          route: 'card',
          persianName: 'کارت',
        },
        {
          route: 'detail',
          persianName: 'جزئیات',
        },
        {
          route: 'filter',
          persianName: 'فیلتر',
        },
        {
          route: 'actions',
          persianName: 'فرآیند',
        },
        {
          route: 'sla',
          persianName: 'زمان بندی',
        },
      ],
    }
  },
  methods: {
    changeView(e) {
      if (e === 'general') {
        this.components = 0
      } else if (e === 'kanban') {
        this.components = 1
      } else if (e === 'filter') {
        this.components = 2
      } else if (e === 'card') {
        this.components = 3
      } else if (e === 'list') {
        this.components = 4
      } else if (e === 'actions') {
        this.components = 4
      } else if (e === 'sla') {
        this.components = 4
      } else if (e === 'detail') {
        this.components = 4
      }
      this.generalKey += 1
    },
    submit() {
      if (this.boardName.replace(/\s/g, '').length == 0) {
        this.showBoardError = true
        this.generalKey += 1
        this.$router.push({ path: 'general' })
      }
      let temp = {
        BoardId: Number(this.$route.query.boardId),
        BoardColumnStatuses: this.columns,
        BoardColumnList: this.availableStatuses,
        TableId: Number(this.$route.query.tableId),
        TableName: this.tableName,
        Searchable: this.searchable,
        Addable: this.addable,
        ShowAll: this.showAll,
        Downloadable: this.downloadable,
        Sortable: this.sortable,
        ButtonKey: this.buttonKey,
        ButtonLink: this.addButtonLink,
        ButtonName: this.addButtonName,
        TableColumnDtoList: this.tableColumns.filter((c) => c.show == true),
        descriptionFieldName: 'FullName',
        filters: [],
        TenantId: '',
        CreatorId: '',
        EpicId: 1,
        IsDelete: false,
        IsActive: false,
        footerFieldName: '',
        TableKey: this.$route.query.teamtaskName,
        leftTitleFieldName: '',
        name: this.boardName,
        rightTitleFieldName: '',
      }
      adminDataProvider.updateSuperADmin(temp).catch((err) => console.log('err', err))
    },
    update(payload) {
      adminDataProvider.updateSuperADmin(payload).catch((err) => console.log('err', err))
    },
    getKanbanData(payload) {
      adminDataProvider
        .getTeamtaskData(payload)
        .then((res) => {
          this.setKanbanColumns(res.data.data.columns)
          this.setAvailableStatuses(res.data.data.availableStatuses)
          this.boardName = res.data.data.name
          for (let i = 0; i < res.data.data.table.columns.length; i++) {
            res.data.data.table.columns[i].showItem = false
            res.data.data.table.columns[i].show = true
            if (i == res.data.data.table.columns.length - 1) {
              this.setTableColumns(res.data.data.table.columns)
              let temp = {
                addable: res.data.data.table.addable,
                searchable: res.data.data.table.searchable,
                downloadable: res.data.data.table.downloadable,
                sortable: res.data.data.table.sortable,
                buttonKey: res.data.data.table.buttonKey,
                showAll: res.data.data.table.showAll,
                teamtaskName: res.data.data.name,
                addButtonLink: res.data.data.table.buttonLink,
                addButtonName: res.data.data.table.buttonName,
              }
              this.setInitialData(temp)
              this.setTableName(res.data.data.table.name)
            }
          }
        })
        .then(() => {
          this.generalKey += 1
        })
        .then(() => {
          this.changeView(this.$route.params.slug)
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  watch: {
    '$route.params.slug'(val) {
      this.changeView(val)
    },
  },
  mounted() {
    let temp = { boardId: this.$route.query.boardId, tableId: this.$route.query.tableId }
    this.getKanbanData(temp)
  },
}
</script>

<style scoped>
@import './style/index.css';
</style>
